import { Component, EventEmitter, Input ,OnInit,Output} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../../core/services/login.service';
import { ToastrService } from 'ngx-toastr';
import { googleConfig } from '../../../../environments/environment';
@Component({
  selector: 'app-login-popup',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './login-popup.component.html',
  styleUrl: './login-popup.component.scss'
})
export class LoginPopupComponent implements OnInit{

  loginform!: FormGroup
  resetEmail!: FormGroup
  showPassword: boolean = false;
  submitted: boolean = false;
  emailControl = new FormControl('', Validators.required);
  displayStyleforget = "none"
  @Input() displayStyle!: boolean;
  @Output() myout: EventEmitter<boolean> = new EventEmitter();
  outputmessage: boolean = false;
  isLoading = false;
  googleLoading = false;
  
  constructor(private fb: FormBuilder,private router: Router, private signIn: LoginService,private toaster: ToastrService){

  }
  ngOnInit() {
    this.loginform = this.fb.group({
      query: this.emailControl,
      password: ['', Validators.required],
    });
  }


  login(data: any) {
    this.submitted = true;
    if (this.loginform.valid) {
      this.isLoading = true;
      this.signIn.postSignIn(data).subscribe({
        next: (res => {
          if (res) {
            this.displayStyle = false;
            this.isLoading = false;
            let href = this.router.url;
            localStorage.setItem("route", href);
            window.location.href = this.router.url;
            this.router.navigate([href]);
          }
        }), error: (error) => {
          this.isLoading = false;
          this.toaster.error(error.error.message);
        }
      })
    }
  }
  
  signInWithGoogle(): void {
    googleConfig.googleClick()
  }

  closePopup() {
    this.displayStyle = false;
    this.myout.emit(this.displayStyle);
    this.loginform.reset();
  }
}
